import React, { Component } from "react";
import { connect } from "react-redux";
import Head from "next/head";

import Link from "next/link";

import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

import Breadcrumbs from "@components/Breadcrumbs";

class Sitemap extends Component {
  render() {
    const { categories } = this.props;

    return (
      <>
        <Head>
          <title>{`Categorii produse`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 99,
              name: `Categorii produse`,
            },
          ]}
        />

        <div>
          <h1 className="u-heading-section">Categorii produse</h1>
          <ul
            className="lg-u-grid lg-u-grid-3 u-space-ml-20 lg-u-space-ml-0"
            style={{
              listStyleType: "upper-roman",
              paddingLeft: 0,
              lineHeight: "1.8em",
            }}
          >
            {categories.map((level1) => (
              <li
                key={level1.id}
                className="u-color-red lg-u-grid-col"
                style={{ display: "list-item", paddingRight: 25 }}
              >
                <div className="u-color-black u-text-no-underline">
                  <Link
                    href={`${settings.baseUrl}/${level1.url_key}/cpl/`}
                    passHref
                  >
                    <a
                      className="u-display-iblock u-text-linkInherit u-text-hover-underline u-text-size-14 u-text-bold u-text-vertical-top"
                      title={level1.name}
                    >
                      {level1.name}
                    </a>
                  </Link>
                </div>
                {level1.subcategories && (
                  <ul style={{ listStyleType: "decimal-leading-zero" }}>
                    {level1.subcategories.map((level2) => (
                      <li key={level2.id} className="u-color-red">
                        <div className="u-color-black u-text-no-underline">
                          <Link
                            href={`${settings.baseUrl}/${level2.url_key}/cpl/`}
                            passHref
                          >
                            <a
                              className="u-display-iblock u-text-linkInherit u-text-hover-underline u-text-vertical-top"
                              title={level2.name}
                            >
                              {level2.name}
                            </a>
                          </Link>
                        </div>
                        {level2.subcategories && (
                          <ul style={{ listStyleType: "lower-alpha" }}>
                            {level2.subcategories.map((level3) => (
                              <li key={level3.id} className="u-color-red">
                                <div className="u-color-black u-text-no-underline">
                                  <Link
                                    href={`${settings.baseUrl}/${level3.url_key}/cpl/`}
                                    passHref
                                  >
                                    <a
                                      className="u-display-iblock u-text-linkInherit u-text-hover-underline u-text-vertical-top"
                                      title={level3.name}
                                    >
                                      {level3.name}
                                    </a>
                                  </Link>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  }
}

Sitemap.pageLayout = "default";

export default connect((state) => ({
  categories: state.mainmenu.data,
}))(Sitemap);
